module.exports = __webpack_public_path__ + "img/ms.8dc575cb.svg";